// This icon file is generated automatically.
var PSafetyCertificateOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.55 1.65L7.24-.15A.77.77 0 007-.2a.77.77 0 00-.24.04l-5.3 1.8a.37.37 0 00-.24.34v7.53c0 .14.09.32.2.4l5.38 4.2c.06.05.13.07.2.07s.14-.02.2-.06l5.38-4.2c.1-.09.2-.27.2-.4V1.98c0-.14-.1-.29-.23-.34zm-.9 7.57L7 12.85 2.34 9.22V2.54L7 .95l4.66 1.6v6.67zM5.33 6.08a.25.25 0 00-.2-.1h-.87c-.1 0-.16.12-.1.2L6.12 8.9c.1.13.31.13.41 0l3.32-4.58c.06-.08 0-.2-.1-.2h-.86a.25.25 0 00-.2.1L6.32 7.48 5.32 6.08z", "fill-rule": "nonzero" } }] }, "name": "p-safety-certificate", "theme": "outlined" };
export default PSafetyCertificateOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PSafetyCertificateOutlined.js
// module id = 3617
// module chunks = 0